import { render, staticRenderFns } from "./HeroTemplate.vue?vue&type=template&id=27648443&scoped=true&lang=html&"
import script from "./HeroTemplate.vue?vue&type=script&lang=js&"
export * from "./HeroTemplate.vue?vue&type=script&lang=js&"
import style0 from "./HeroTemplate.vue?vue&type=style&index=0&id=27648443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27648443",
  null
  
)

export default component.exports